import { Component, OnInit } from '@angular/core';
import { Router } from "@angular/router";
import { timer } from 'rxjs/observable/timer';
import { Observable } from 'rxjs/Observable';

//Servicios
import { DefaultService } from '../../services/default.service';

//Jquery
declare var jQuery:any;
declare var $:any;

@Component({
  selector: 'app-registro',
  templateUrl: './registro.component.html',
  styleUrls: ['./registro.component.css'],
  providers: [
    DefaultService
  ]
})
export class RegistroComponent implements OnInit {

  public datosUser:any = {};
  public login:any = {};
  public RecPass:any = {};
  public errorPass:number = 0;
  public showAviso:boolean = false;
  public showAvisoEmail:boolean = false;
  public showRecPass:boolean = false;
  public success:boolean = false;
  public success2:boolean = false;

  constructor(
    public _defaultService: DefaultService,
    public router: Router
  ){ 

  }

  ngOnInit() {

  }

  showPass(){
    if(this.showRecPass){
       this.showRecPass = false;
       this.success2 = true;
       timer(1000).subscribe(() => this.success2 = false);
    }else{
      this.showRecPass = true;
      this.success = true;
      timer(1000).subscribe(() => this.success = false);
    }
  }

  ValidatePass(type){
    if(this.datosUser.password != this.datosUser.passwordRep){
      if(type == 1){
        if(this.datosUser.passwordRep != "" && this.datosUser.passwordRep != undefined){
          if(this.datosUser.password == this.datosUser.passwordRep && this.datosUser.password.length >=8 ){
            this.errorPass = 0;
          }else{
            this.datosUser.password = "";
            this.datosUser.passwordRep = "";
            this.errorPass = 1;
          }
        }
      }else{
        if(this.datosUser.password != "" && this.datosUser.password != undefined){
          if(this.datosUser.password == this.datosUser.passwordRep && this.datosUser.password.length >=8 ){
            this.errorPass = 0;
          }else{
            this.datosUser.password = "";
            this.datosUser.passwordRep = "";
            this.errorPass = 1;
          }
        }
      }

    }
  }

  recpass(){
     this._defaultService.recuperarPass(this.RecPass.email);
     this.showRecPass = false;
     this.RecPass = {};
  }

  closeAviso(){
    this.showAviso = false;
    this.showAvisoEmail = false;
  }
  

  registro(){
    if(this.datosUser.password.length < 6){
      this.showAviso = true;
      this.showAvisoEmail = false;
    }else{
      var booEmail = this.caracteresCorreoValido(this.datosUser.email);
      if(booEmail){
        this._defaultService.registro(this.datosUser.email, this.datosUser.password, this.datosUser);
      }else{
        this.showAvisoEmail = true;
        this.showAviso = false;
      }

    }
  }

  Logeo(){
    this._defaultService.login(this.login.email, this.login.password)
  }

  caracteresCorreoValido(email){
    var caract = new RegExp(/^([a-zA-Z0-9_.+-])+\@(([a-zA-Z0-9-])+\.)+([a-zA-Z0-9]{2,4})+$/);

    if (caract.test(email) == false){
        return false;
    }else{
        return true;
    }
}
}



// WEBPACK FOOTER //
// ./src/app/registro/registro.component.ts